import CryptoJS from 'crypto-js'
import { ENCRYPTION_KEY } from './encrypt-key'

export default function encrypt(value: any) {
  return CryptoJS.AES.encrypt(JSON.stringify(value), ENCRYPTION_KEY).toString()
}
